import { Component, OnInit, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { UtilityService } from '../services/utility.service';
import { MasterService } from '../services/master-mom.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormGroup, NgForm } from '@angular/forms';
import { ToastrUtilsService } from '../services/toastr-utils.service';
import { ModalDirective, BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router, ActivatedRoute, Params,NavigationEnd  } from '@angular/router';
import { UserService } from '../services/user.service'
import * as $ from 'jquery';
import { CweditsectionComponent } from '../cweditsection/cweditsection.component';
import { UserInfo } from '../userinfo';
import { ToasterService } from '../toaster/toaster.service';
import { environment } from 'src/environments/environment';
import { SidebarComponent } from '../layout/sidebar/sidebar.component'
import { Subscription } from 'rxjs';
import { RSAHelper } from '../services/RSAHelper';
import { AuthorizationService } from '../services/authorization.service';
import { TokenResponse } from '@openid/appauth';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [ToastrUtilsService]
})
export class HomeComponent implements OnInit {
    shouldShowcolumn = false; popupdata1: any = []; menuSectionname: string = "";
    menuSectionid: string = "0"; sectioninfosaved: boolean = false;
    limit = 5;
    page = 1;
    txtFilter = ''; sectiontitle: string = "";
    p = 1; popupimageLoader: boolean = false;
    @ViewChild('closeBtn') closeBtn: ElementRef;
    listview: boolean = false; public modalRef: BsModalRef;
    userApplnList: any = []; usersectionInfoList: any = []; editSectionid: string = "0";
    editSectionname: string = ""; user: any = [];
    recentinfolist: any = []; recentinfo: boolean = false; loginemail: string;
    showrecentinfo: boolean = false; showusersection: boolean = false; userprofileInfo: any = [];
    useremail: string = ""; imageLoader: boolean = false;
    sectionformvalue: string = ""; submitcnt: number = 0; public authorized: boolean;
    oldsectionname: string = ""; subscription: Subscription; imgdynamicurl = '';
    constructor(private utilservice: UtilityService, public RSAHelper: RSAHelper, private authorizationService: AuthorizationService, public router: Router, private activatedRoute: ActivatedRoute, private modalService: BsModalService, private userService: UserService, private spinner: NgxSpinnerService, public masterservice: MasterService, private toastr: ToastrUtilsService) {
        this.imgdynamicurl = environment.imgdynamicurl;
    }

    /*SuccessCustomMessage(message:string) {
        //debugger;
        this.toastr.show('success', message,'',0);
    }
    ErrorCustomMessage(msg:string) {
        this.toastr.clearall();
        this.toastr.show('error', msg+'home');
    }
    showWarningToaster(msg:string) {
        this.toastr.show('warning', msg, 'This is a warning alert', 3000);
    }*/

    ngOnInit() { 

    //to check the existing login
    this.Authorize();
    this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          window.location.reload(); // Refresh the page
        }
      });

    }

    checkUserDetails(){
        
        this.user = this.userService.getUserInfo();
        //this.userprofileInfo=this.userService.getUserProfileInfo();
        console.log('Home' + this.user);
        this.listview = true;
        this.activatedRoute.queryParams.subscribe(params => {
            this.menuSectionid = params['sectionid']
            this.menuSectionname = params['sectionName']
        });
        this.menuSectionid = this.menuSectionid == null ? "0" : this.menuSectionid;

        if (!environment.production) {
            this.useremail = environment.testEmail;
            //this.loadUserApplnList(this.menuSectionid, this.menuSectionname,this.useremail);
        }
        else {
            this.useremail = this.user.email;
            //this.loadUserApplnList(this.menuSectionid, this.menuSectionname,this.useremail);
        }

        this.RefreshSecurityToken(this.useremail);
        this.routeToAppCatalog();

        this.showhidesections();


        // this.subscription = this.utilservice.getsidebar().subscribe(data => {
        //     console.log(this.menuSectionid + " " + this.menuSectionname);
        //     if (this.useremail != null)
        //         this.activatedRoute.queryParams.subscribe(params => {
        //             this.menuSectionid = params['sectionid']
        //             this.menuSectionname = params['sectionName']
        //         });
        //     this.menuSectionid = (this.menuSectionid == null) || (this.menuSectionid == undefined) ? "0" : this.menuSectionid;
        //     this.showhidesections();
        //     this.loadUserApplnList(this.menuSectionid, this.menuSectionname, this.useremail);
        // });

    }

    Authorize() {
        this.authorizationService.tokenResponse().subscribe((tokenResponse: TokenResponse) => {
            this.authorized = tokenResponse != null;
            if (!this.authorized) {
                console.log('call authorize');
                this.authorizationService.authorize();
                this.authorizationService.tokenResponse().subscribe((tokenResponse: TokenResponse) => {
                    this.authorized = tokenResponse != null;
                    if (this.authorized) {
                        this.checkUserDetails();
                    } else {

                    }
                });
            }else{
                this.checkUserDetails();
            }
        });

    }

    RefreshSecurityToken(userEmail) {
        try {

            const objTxnData = {
                "email": userEmail,
                "isExternal": environment.isExternal
            };
            let encryptedioparam = this.RSAHelper.encryptWithPublicKey(JSON.stringify(objTxnData));
            this.masterservice.refreshToken(JSON.stringify(encryptedioparam)).subscribe((result: any) => {
                console.log(result);
                sessionStorage.removeItem('iammwtoken');
                sessionStorage.setItem('iammwtoken', result.token);
                this.loadUserApplnList(this.menuSectionid, this.menuSectionname, this.useremail);

                
        this.subscription = this.utilservice.getsidebar().subscribe(data => {
            console.log(this.menuSectionid + " " + this.menuSectionname);
            if (this.useremail != null)
                this.activatedRoute.queryParams.subscribe(params => {
                    this.menuSectionid = params['sectionid']
                    this.menuSectionname = params['sectionName']
                });
            this.menuSectionid = (this.menuSectionid == null) || (this.menuSectionid == undefined) ? "0" : this.menuSectionid;
            this.showhidesections();
            this.loadUserApplnList(this.menuSectionid, this.menuSectionname, this.useremail);
        });

            },
                (error) => {
                    sessionStorage.removeItem('iammwtoken');
                    this.spinner.hide();
                }
            ).add(() => {
                this.spinner.hide();
            });
        }
        catch (err) { console.log(err); }
    }



    routeToAppCatalog() {
        try {
            //this.userprofileInfo = this.userService.getUserProfileInfo(this.useremail);
            this.userService.getUserProfileInfo(this.useremail).
                subscribe((result: any) => {
                    var response;
                    if (result.data == undefined) { response = result; this.userprofileInfo = response; }
                    else { response = result.data; this.userprofileInfo = JSON.parse(this.userService.loadprofiledata(response)); }
                    if (response != null) {
                        //if(this.userprofileInfo!=null)
                        //{
                        const firsttimeaccesstoiam = this.userprofileInfo.firsttimeaccesstoiam;
                        //JSON.parse(this.userprofileInfo).firsttimeaccesstoiam;
                        if (firsttimeaccesstoiam == 1) {
                            this.router.navigateByUrl("/home/AppCatalog");
                        }
                    }
                });
        }
        catch (e) { console.log(e); }
    }

    showhidesections() {
        try {
            if (this.menuSectionid == "0") {
                this.showrecentinfo = true; this.showusersection = true;
            }
            else if (this.menuSectionname == "Recently Used") {
                this.showusersection = false;
            }
            else {
                this.showrecentinfo = false;
            }
        }
        catch (err) { console.log(err); }
    }

    getuserprofileinfo() {
        if ((this.userprofileInfo == null) || (this.userprofileInfo == "")) {
            this.userprofileInfo = this.userService.getUserProfileInfo(this.useremail);
        }
        //this.userprofileInfo=JSON.parse(this.userprofileInfo)
    }


    openapp(rowData) {
        try {
            //debugger;
            /* removed click to be reverted back*/
            window.open(rowData.applnurl);
        }
        catch (err) { console.log(err); }
    }

    addToRecentItem(rowData) {

        try {
            //window.open(rowData.applnurl); //moved up from addToRecent result
            this.userService.getUserProfileInfo(this.useremail).subscribe((result: any) => {
                var response; if (result.data == undefined) { response = result; this.userprofileInfo = response; }
                else { response = result.data; this.userprofileInfo = JSON.parse(this.userService.loadprofiledata(response)); }
                if (response != null) {
                    const objTxnData = {
                        "employeeuno": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.userprofileInfo.employeeuno)),
                        "appid": this.RSAHelper.encryptWithPublicKey(JSON.stringify(rowData.appid.toString())),
                        "PRNumber": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.userprofileInfo.userPRnumber)),
                        "email": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.useremail))
                    }

                    this.masterservice.addToRecent(JSON.stringify(objTxnData)).subscribe((result: any) => {
                        const response = result.data;
                        if (response.dictionary.IntResult > 0) {
                            this.loadUserApplnList(this.menuSectionid, this.menuSectionname, this.useremail);
                            //window.open(rowData.applnurl);
                        }
                        else {
                            // this.toastr.ErrorCustomMessage('There was an unexpected error.');
                        }
                    }, (error) => {
                        //this.toastr.ErrorCustomMessage('There was an unexpected error.');
                        this.spinner.hide();
                    }).add(() => {
                        this.spinner.hide();
                    });
                }
            });
        }
        catch (err) {
            this.toastr.ErrorCustomMessage('There was an unexpected error.');
            this.spinner.hide();
        }
    }

    //get all applications
    LoadApplication(useremail: string) {
        try {
            const objTxnData = {
                "email": this.RSAHelper.encryptWithPublicKey(JSON.stringify(useremail)),
                "isExternal": this.RSAHelper.encryptWithPublicKey(JSON.stringify(environment.isExternal)),
            };

            this.masterservice.allApplns(JSON.stringify(objTxnData)).subscribe((result: any) => {
                //this.popupdata = result.data;
                var resultdata = result.data;
                for (let i = 0; i < resultdata.length; i++) {
                    for (let j = 0; j < resultdata[i].applicationInfo.length; j++) {
                        let appid = resultdata[i].applicationInfo[j].appid;
                        if (this.popupdata1.filter(item => item.appid == appid) == 0)
                            //push only if appid is not in the section
                            this.popupdata1.push(resultdata[i].applicationInfo[j]);
                    }
                }

                //setTimeout(() => { this.spinner.hide(); }, 1000);            
            },
                (error) => {
                    //console.log(error);
                    this.toastr.ErrorCustomMessage('There was an unexpected error.');
                    this.spinner.hide();
                }
            ).add(() => {
                // Called when operation is complete (both success and error)
                // this.spinner.hide();
                this.spinner.hide();
            });
        }
        catch (err) { console.log(err); }
    }

    AddNewSection() {
        try {
            //this.getuserprofileinfo();
            debugger;
            const selectedApps = this.popupdata1.filter(item => item.checked === true);
            if (selectedApps.length == 0) {
                this.toastr.showWarningToaster('Please select apps');
                return;
            }
            if (this.sectiontitle.trim() == "") {
                this.toastr.showWarningToaster("Please enter section name");
                return;
            }
            //console.log(selectedApps);
            var appID = '';
            for (var apps of selectedApps) {
                appID = appID + "," + apps.appid;
            }
            if (appID.substring(0, 1) == ",") appID = appID.slice(1);
            console.log(appID);

            this.userService.getUserProfileInfo(this.useremail).
                subscribe((result: any) => {
                    var response;
                    if (result.data == undefined) {
                        response = result;
                        this.userprofileInfo = response;
                    }
                    else { response = result.data; this.userprofileInfo = JSON.parse(this.userService.loadprofiledata(response)); }
                    //const response = result;
                    if (response != null) {
                        const objTxnData = {
                            "sectionname": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.sectiontitle)),
                            "employeeuno": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.userprofileInfo.employeeuno)),
                            "appid": this.RSAHelper.encryptWithPublicKey(JSON.stringify(appID)),
                            "PRNumber": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.userprofileInfo.userPRnumber)),
                            "email": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.useremail))
                        }

                        this.masterservice.AddNewSection(JSON.stringify(objTxnData))
                            .subscribe((result: any) => {
                                const response = result.data;
                                if (response.dictionary.IntResult > 0) {
                                    this.toastr.SuccessCustomMessage('Section added successfully.');
                                    //redirect to myApps page
                                    //this.router.navigate(['home']);
                                    //this.LoadApplication(this.useremail);
                                    this.closeBtn.nativeElement.click();
                                    this.loadUserApplnList(this.menuSectionid, this.menuSectionname, this.useremail);
                                    this.utilservice.updateData("Section added successfully.");
                                } else {
                                    this.toastr.ErrorCustomMessage('There was an unexpected error.');
                                }
                            },
                                (error) => {
                                    this.toastr.ErrorCustomMessage('There was an unexpected error.');
                                    this.spinner.hide();
                                }
                            ).add(() => {
                                this.spinner.hide();
                            });
                    }
                });
        }
        catch (err) {
            this.toastr.ErrorCustomMessage('There was an unexpected error.');
            //console.log(err);
            this.spinner.hide();
        }
    }

    EditSection(rowData)//Building the popup window
    {
        try {

            this.popupdata1 = []; this.sectioninfosaved = false;
            this.editSectionname = "Add Section";
            this.sectiontitle = "";
            if (rowData != null) {
                this.oldsectionname = rowData.sectionName;
                this.editSectionname = rowData.sectionName;
                this.sectiontitle = this.editSectionname;
                //this.editSectionname = rowData.sectionName;
                this.editSectionid = rowData.sectionId;
                //this.popupdata1=rowData.applicationInfo;     
                for (let i = 0; i < rowData.applicationInfo.length; i++) {
                    this.popupdata1.push(rowData.applicationInfo[i]);
                }
                //this.popupdata1.push(rowData.applicationInfo);
                this.popupdata1.forEach(function (e) {
                    if (typeof e === "object") {
                        e["checked"] = true
                    }
                });
            }
            //Load all other pending applications
            this.LoadApplication(this.useremail);
        }
        catch (err) { console.log(err); }
    }

    RemoveSelection() {
        try {

            for (var app of this.popupdata1) {
                app.checked = false;
            }
        }
        catch (err) { console.log(err); }
    }

    RemoveSection() {

        this.popupimageLoader = true;
        //this.getuserprofileinfo();
        try {
            this.userService.getUserProfileInfo(this.useremail).
                subscribe((result: any) => {
                    var response;
                    if (result.data == undefined) {
                        response = result;
                        this.userprofileInfo = response;
                    }
                    else { response = result.data; this.userprofileInfo = JSON.parse(this.userService.loadprofiledata(response)); }
                    //const response = result;
                    if (response != null) {
                        const objTxnData = {
                            "sectionname": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.editSectionname)),
                            "sectionid": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.editSectionid)),
                            "employeeuno": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.userprofileInfo.employeeuno)),
                            "PRNumber": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.userprofileInfo.userPRnumber)),
                            "email": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.useremail))
                        }

                        this.masterservice.delSection(JSON.stringify(objTxnData))
                            .subscribe((result: any) => {
                                const response = result.data;
                                var intresult = response.dictionary == undefined ? response.intResult : response.dictionary.IntResult;
                                if (intresult > 0) {
                                    this.utilservice.updateData("Section removed successfully.");
                                    this.toastr.SuccessCustomMessage('Section removed successfully.');
                                    this.sectioninfosaved = true;
                                    this.closeBtn.nativeElement.click();
                                    //console.log(this.sectioninfosaved);
                                    this.loadUserApplnList(this.menuSectionid, this.menuSectionname, this.useremail);

                                }
                                else {
                                    this.toastr.ErrorCustomMessage('There was an unexpected error.');
                                }
                            },
                                (error) => {
                                    this.toastr.ErrorCustomMessage('There was an unexpected error.');
                                    this.spinner.hide(); this.popupimageLoader = false;
                                }
                            ).add(() => {
                                this.spinner.hide(); this.popupimageLoader = false;
                            });
                    }
                });
        }
        catch (err) {
            console.log(err);
            this.spinner.hide(); this.popupimageLoader = false;
            this.closeBtn.nativeElement.click();
        }
    }

    loaduserprofile() {
        try {

            var usersectionInfoList: any;
            const objTxnData = {
                "email": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.useremail))
            }
            this.masterservice.getprofileinfo(JSON.stringify(objTxnData))
                .subscribe((result: any) => {
                    const response = result.data;
                    if (response.length > 0) {
                        usersectionInfoList = result.data;

                        var employeeuno = (usersectionInfoList[0].employeeuno != null && usersectionInfoList[0].employeeuno !== '') ? usersectionInfoList[0].employeeuno : '';
                        //var firstname = (usersectionInfoList[0].first_Name != null && usersectionInfoList[0].first_Name !== '') ? usersectionInfoList[0].first_Name : '';
                        var firstname = (usersectionInfoList[0].first_name != null && usersectionInfoList[0].first_name != "") ? usersectionInfoList[0].first_name : '';
                        var lastname = (usersectionInfoList[0].last_name != null && usersectionInfoList[0].last_name != "") ? usersectionInfoList[0].last_name : '';
                        var email = (usersectionInfoList[0].emailId != null && usersectionInfoList[0].emailId != "") ? usersectionInfoList[0].emailId : '';
                        var userPRnumber = (usersectionInfoList[0].corporate_id != null && usersectionInfoList[0].corporate_id != "") ? usersectionInfoList[0].corporate_id : '';
                        var division = (usersectionInfoList[0].division != null && usersectionInfoList[0].division != "") ? usersectionInfoList[0].division : '';
                        var designation = (usersectionInfoList[0].jobtitle != null && usersectionInfoList[0].jobtitle != "") ? usersectionInfoList[0].jobtitle : '';
                        var struser = '{"employeeuno": "' + employeeuno + '","firstname":"' + firstname + '","lastname":"' + lastname + '","email":"' + email + '","division":"' + division + '","designation":"' + designation + '","userPRnumber":"' + userPRnumber + '"}';
                        sessionStorage.removeItem('userinfo');
                        sessionStorage.setItem('userinfo', struser);
                        this.userprofileInfo = JSON.parse(sessionStorage.getItem('userinfo'));
                    }
                });
        }
        catch (e) { console.log(e); }
    }

    //For new section    
    //For edit
    Save() {
        //this.getuserprofileinfo();
        //const selectedrows = this.popupdata1.filter(item => item.checked === true);
        this.popupimageLoader = true;
        try {
            debugger;
            const selectedApps = this.popupdata1.filter(item => item.checked == true);
            var appID = '';
            for (var apps of selectedApps) {
                appID = appID + "," + apps.appid;
            }
            if (selectedApps.length == 0) {
                this.toastr.showWarningToaster('Please select apps');
                this.popupimageLoader = false;
                return;
            }
            if (appID.substring(0, 1) == ",") appID = appID.slice(1);
            //console.log(appID);
            this.userService.getUserProfileInfo(this.useremail).
                subscribe((result: any) => {
                    var response;
                    if (result.data == undefined) {
                        response = result;
                        this.userprofileInfo = response;
                    }
                    else { response = result.data; this.userprofileInfo = JSON.parse(this.userService.loadprofiledata(response)); }
                    //const response = result;
                    if (response != null) {
                        const objTxnData = {
                            "oldsectionname": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.oldsectionname)),
                            "newsectionname": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.sectiontitle)),
                            "sectionid": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.editSectionid)),
                            "employeeuno": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.userprofileInfo.employeeuno)),
                            "appid": this.RSAHelper.encryptWithPublicKey(JSON.stringify(appID)),
                            "PRNumber": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.userprofileInfo.userPRnumber)),
                            "email": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.useremail))
                        }

                        // let encryptedioparam = this.RSAHelper.encryptWithPublicKey(JSON.stringify(objTxnData)); 
                        this.masterservice.updSection(objTxnData)
                            .subscribe((result: any) => {
                                const response = result.data;
                                var intresult = response.dictionary == undefined ? response.intResult : response.dictionary.IntResult;
                                if (intresult > 0) {
                                    this.toastr.SuccessCustomMessage('Section Updated successfully.');
                                    this.sectioninfosaved = true;
                                    this.closeBtn.nativeElement.click();
                                    console.log(this.sectioninfosaved);
                                    this.loadUserApplnList(this.menuSectionid, this.menuSectionname, this.useremail);
                                    this.utilservice.updateData("Section updated successfully.");
                                }
                                else {
                                    this.toastr.ErrorCustomMessage('There was an unexpected error.');
                                }
                            },
                                (error) => {
                                    this.toastr.ErrorCustomMessage('There was an unexpected error.');
                                    this.spinner.hide(); this.popupimageLoader = false;
                                }
                            ).add(() => {
                                this.spinner.hide(); this.popupimageLoader = false;
                            });
                    }
                });
        }
        catch (err) {
            console.log(err);
            this.spinner.hide(); this.popupimageLoader = false;
            this.closeBtn.nativeElement.click();
        }
    }

    loadUserApplnList(sectionid: string, sectionname: string, emailid: string) {
        try {
            var sectionidv = sectionid == undefined ? "0" : sectionid;
            var sectionnamev = sectionname == undefined ? "0" : sectionname;

            this.spinner.show();
            this.imageLoader = true;
            this.sectiontitle = "";

            const objTxnData = {
                "email": this.RSAHelper.encryptWithPublicKey(JSON.stringify(emailid)),
                "sectionid": this.RSAHelper.encryptWithPublicKey(JSON.stringify(sectionidv)),
                "sectionname": this.RSAHelper.encryptWithPublicKey(JSON.stringify(sectionnamev)),
                "isExternal": this.RSAHelper.encryptWithPublicKey(JSON.stringify(environment.isExternal))
            };

            this.masterservice.userApplnList(JSON.stringify(objTxnData)).subscribe((result: any) => {
                console.log(result.data);
                if (result.data != null) {
                    this.userApplnList = []; this.recentinfolist = [];
                    this.userApplnList = result.data;
                    //this.loaduserprofile();
                    this.recentinfolist = this.userApplnList.filter(function (applnInfo) {
                        return applnInfo.sectionName == "Recently Used";
                    });

                    if ((this.recentinfolist != undefined) && (this.recentinfolist.length > 0)) this.recentinfo = true;
                    this.usersectionInfoList = this.userApplnList.filter(function (applnInfo) {
                        return applnInfo.sectionName != "Recently Used";
                    });
                    if ((this.menuSectionid != "0") && (this.menuSectionname != "Recently Used")) this.recentinfolist = [];
                    //Show all applications in the catalog
                    if (this.menuSectionid == "0") {
                        this.LoadApplication(this.useremail);
                    }
                    setTimeout(() => { this.spinner.hide(); this.imageLoader = false; }, 1000);
                }
                else {
                    this.toastr.showWarningToaster("No records found");
                }
            },
                (error) => {
                    console.log(error);
                    this.toastr.ErrorCustomMessage('There was an unexpected error.');
                    this.spinner.hide(); this.imageLoader = false;
                }
            ).add(() => {
                // Called when operation is complete (both success and error)          
                this.spinner.hide(); this.imageLoader = false;
            });
        }
        catch (err) { console.log(err); this.imageLoader = false; }
    }

    onSubmit(form: NgForm, formname: string) {
        debugger;
        try {
            if (formname == "addsection") {
                this.submitcnt = this.submitcnt + 1;
                //this.sectionformvalue=form.value.newsectionname;   
                this.sectionformvalue = form.value.sectiontitle;
                if (form.valid) { this.AddNewSection(); }
                //console.log(this.submitcnt);
            }
            else if ((formname == "editsection")) {
                this.sectionformvalue = form.value.sectiontitle;
                this.submitcnt = this.submitcnt + 1;
                if (form.valid) this.Save();
                console.log(this.submitcnt);
            }
        }
        catch (err) { console.log(err); }
    }

    ngOnDestroy() {
        try {

            this.subscription.unsubscribe();
        } catch (err) { console.log(err); }
    }
}